<app-page-breadcrumb pageTitle="Métricas de llamadas"></app-page-breadcrumb>

<div class="space-y-6">

  <!-- Filtros + export -->
  <app-component-card>
    <div class="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 flex-1">
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Desde</label>
          <input
            type="date"
            [(ngModel)]="fromDate"
            (click)="$any($event.target).showPicker?.()"
            class="w-full rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 dark:[color-scheme:dark] cursor-pointer">
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Hasta</label>
          <input
            type="date"
            [(ngModel)]="toDate"
            (click)="$any($event.target).showPicker?.()"
            class="w-full rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 dark:[color-scheme:dark] cursor-pointer">
        </div>
      </div>
      <div class="flex gap-2">
        <app-button variant="outline" (btnClick)="refrescar()" [disabled]="loading">
          {{ loading ? 'Cargando...' : 'Aplicar' }}
        </app-button>
        <app-button variant="primary" (btnClick)="exportarCsv()" [disabled]="exporting">
          {{ exporting ? 'Exportando...' : 'Exportar CSV' }}
        </app-button>
      </div>
    </div>
  </app-component-card>

  @if (errorMsg) {
  <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <p class="text-sm text-error-600 dark:text-error-400">{{ errorMsg }}</p>
  </div>
  }

  <!-- KPI Cards -->
  <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
    <div class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4">
      <p class="text-xs uppercase tracking-wider text-gray-500 dark:text-gray-400">Llamadas totales</p>
      <p class="mt-1 text-2xl font-bold text-gray-900 dark:text-white">{{ dashboard?.totalCalls ?? 0 }}</p>
      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
        {{ dashboard?.inboundCalls ?? 0 }} in · {{ dashboard?.outboundCalls ?? 0 }} out
      </p>
    </div>

    <div class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4">
      <p class="text-xs uppercase tracking-wider text-gray-500 dark:text-gray-400">Respondidas</p>
      <p class="mt-1 text-2xl font-bold text-success-600 dark:text-success-400">{{ dashboard?.answeredCalls ?? 0 }}</p>
      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ answerRate() }}% de respuesta</p>
    </div>

    <div class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4">
      <p class="text-xs uppercase tracking-wider text-gray-500 dark:text-gray-400">Perdidas</p>
      <p class="mt-1 text-2xl font-bold text-error-600 dark:text-error-400">{{ dashboard?.missedCalls ?? 0 }}</p>
      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">No contestadas / falladas</p>
    </div>

    <div class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4">
      <p class="text-xs uppercase tracking-wider text-gray-500 dark:text-gray-400">Duración promedio</p>
      <p class="mt-1 text-2xl font-bold text-brand-600 dark:text-brand-400">{{ formatDuration(dashboard?.avgDurationSeconds) }}</p>
      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
        Total: {{ formatDuration(dashboard?.totalDurationSeconds) }}
      </p>
    </div>
  </div>

  <!-- Tabla por agente -->
  <app-component-card title="Por agente" desc="Distribución de llamadas atendidas por cada agente.">
    @if (loadingAgents) {
    <div class="flex justify-center py-8">
      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
    </div>
    } @else if (agents.length === 0) {
    <p class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">
      No hay actividad por agente en el período.
    </p>
    } @else {
    <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 dark:bg-gray-800">
          <tr>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Agente</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400">Total</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400">In / Out</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400">Respondidas</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400">Perdidas</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400">Talk time</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400">Promedio</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Presencia</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Última llamada</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
          @for (a of agents; track trackByAgentId($index, a)) {
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50">
            <td class="px-3 py-2">
              <div class="flex items-center gap-2">
                <span class="font-medium text-gray-900 dark:text-white" [title]="'Identificador interno: ' + a.agentId">{{ a.agentName || '—' }}</span>
              </div>
            </td>
            <td class="px-3 py-2 text-right font-semibold text-gray-900 dark:text-white">{{ a.totalCalls }}</td>
            <td class="px-3 py-2 text-right text-xs text-gray-600 dark:text-gray-400">{{ a.inboundCalls }} / {{ a.outboundCalls }}</td>
            <td class="px-3 py-2 text-right">
              <span class="text-success-700 dark:text-success-400">{{ a.answeredCalls }}</span>
              <span class="text-xs text-gray-500 dark:text-gray-400 ml-1">({{ agentAnswerRate(a) }}%)</span>
            </td>
            <td class="px-3 py-2 text-right text-error-600 dark:text-error-400">{{ a.missedCalls }}</td>
            <td class="px-3 py-2 text-right text-gray-700 dark:text-gray-300">{{ formatDuration(a.totalTalkTimeSeconds) }}</td>
            <td class="px-3 py-2 text-right text-gray-700 dark:text-gray-300">{{ formatDuration(a.avgTalkTimeSeconds) }}</td>
            <td class="px-3 py-2">
              @if (a.presenceStatus === 'AVAILABLE') {
              <span class="inline-flex items-center gap-1 rounded-full bg-success-50 px-2 py-0.5 text-xs font-medium text-success-700 dark:bg-success-500/10 dark:text-success-400">
                <span class="h-1.5 w-1.5 rounded-full bg-success-500"></span> Disponible
              </span>
              } @else if (a.presenceStatus === 'BUSY') {
              <span class="inline-flex items-center gap-1 rounded-full bg-warning-50 px-2 py-0.5 text-xs font-medium text-warning-700 dark:bg-warning-500/10 dark:text-warning-400">
                <span class="h-1.5 w-1.5 rounded-full bg-warning-500"></span> Ocupado
              </span>
              } @else if (a.presenceStatus === 'ON_BREAK') {
              <span class="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700 dark:bg-blue-500/10 dark:text-blue-400">
                <span class="h-1.5 w-1.5 rounded-full bg-blue-500"></span> En pausa
              </span>
              } @else {
              <span class="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700 dark:bg-gray-700 dark:text-gray-300">
                <span class="h-1.5 w-1.5 rounded-full bg-gray-400"></span> {{ presenceLabel(a.presenceStatus) }}
              </span>
              }
            </td>
            <td class="px-3 py-2 text-xs text-gray-600 dark:text-gray-400">{{ formatDate(a.lastCallAt) }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </app-component-card>
</div>
